import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { resetPassword } from './actions';
import ResetPasswordForm from './ResetPasswordForm';
import { Grid, Row, Col, Breadcrumb } from 'react-bootstrap';
import LanguageMenu from '../languages/LanguageMenu';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import { RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE } from './actions';

class ResetPassword extends React.Component {

	constructor(props) {
		super(props);
		this.handleOnSubmit = this.handleOnSubmit.bind(this);
	}

	componentDidMount() {
		document.body.classList.add('login-background');
	}

	componentWillUnmount() {
		document.body.classList.remove('login-background');
	}

	handleOnSubmit(values) {
		const { resetPassword, history } = this.props;

		resetPassword(values, history);

	}

	render() {

		const { t, franchisor, languages } = this.props;
		const initialValues = {
			passwordResetToken: this.props.passwordResetToken
		};
		const logoImg = franchisor && franchisor.logoUrl;

		return (
			<Grid fluid>
				<Row>
					<Col>
						<Breadcrumb className='login-breadcrumb'>
							{languages.length > 1 && <LanguageMenu languages={languages} />}
						</Breadcrumb>
					</Col>
				</Row>
				<Row className='body-simulate'>
					<div className='login example2'>
						<div className='main-login col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3'>
							{logoImg && <div className='logo'><img src={logoImg} /></div>}
							{!logoImg && <div className='logo'>{t('ResetPassword_Title', { systemName: franchisor && franchisor.systemName.toUpperCase() })}</div>}
							<ReduxBlockUi block={RESET_PASSWORD_REQUEST} unblock={[RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE]}>
								<div className='box-login'>
									<h3>{t('ResetPassword_ResetPassword')}</h3>
									<p>{t('ResetPassword_Text')}</p>
									<ResetPasswordForm onSubmit={this.handleOnSubmit} initialValues={initialValues} />
								</div>
							</ReduxBlockUi>
						</div>
					</div>
				</Row>
			</Grid>
		);
	}

}

ResetPassword.propTypes = {
	resetPassword: PropTypes.func,
	location: PropTypes.object,
	isAuthenticated: PropTypes.bool,
	errors: PropTypes.array
};

const mapStateToProps = (state, ownProps) => {
	const { passwordResetToken } = queryString.parse(ownProps.location.search);
	const { configuration: { franchisor }, lookups: { languages } } = state;
	return {
		passwordResetToken,
		franchisor,
		languages
	};
};

export default connect(mapStateToProps, { resetPassword })(withTranslation()(ResetPassword));